import _ from 'lodash';

import { useTranslationsContext } from '../../../context/TranslationsContext';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import {
  packageMonitor,
  secureBusinessAllowedChannelsList,
  sixMonthsFree,
  tsbSecurityOffersObject
} from '../../../utils/constant';

const locale = getLocale();
const {
  WLS: {
    _tenDollarOff
  }
} = locale === 'en-US' ? EN : FR;

const getSecureBusinessOffersList = (userChannelName, listOfAllOptions, fieldValue, securityPackageValue) => {
  const translations = useTranslationsContext();
  const {
    contentfulValues: {
      secureBusinessOffers: {
        threeMonthFree,
        tenOffWirelene,
        twentyOffWireline,
        tenOffMpp,
        twentyOffMpp
      }
    }
  } = translations;

  const optionsList = listOfAllOptions.reduce((acc, item) => {
    const { fields } = item;
    const { value } = fields;

    if (
      fieldValue &&
      fieldValue.includes(tenOffWirelene) &&
      value === twentyOffWireline
    ) {
      return acc;
    }

    if (
      fieldValue &&
      fieldValue.includes(twentyOffWireline) &&
      value === tenOffWirelene
    ) {
      return acc;
    }

    if (
      fieldValue &&
      fieldValue.includes(sixMonthsFree) &&
      value === threeMonthFree
    ) {
      return acc;
    }

    if (
      fieldValue &&
      fieldValue.includes(threeMonthFree) &&
      value === sixMonthsFree
    ) {
      return acc;
    }
    // handling toggle of 20$ offer with 10$ bundle discount offer
    if (
      fieldValue &&
      fieldValue.includes(
        tsbSecurityOffersObject.twentyDollarOffEn ||
        tsbSecurityOffersObject.twentyDollarOffFr
      ) &&
      value ===
      (tsbSecurityOffersObject.tenBundleDiscountEn ||
        tsbSecurityOffersObject.tenBundleDiscountFr)
    ) {
      return acc;
    }
    // handling toggle of 20$ offer with 5$ off
    if (
      fieldValue &&
      fieldValue.includes(
        tsbSecurityOffersObject.twentyDollarOffEn ||
        tsbSecurityOffersObject.twentyDollarOffFr
      ) &&
      value === _tenDollarOff
    ) {
      return acc;
    }
    // handling toggle of 10$ offer with 20$ bundle discount offer
    if (
      fieldValue &&
      fieldValue.includes(
        tsbSecurityOffersObject.tenBundleDiscountEn ||
        tsbSecurityOffersObject.tenBundleDiscountFr
      ) &&
      value ===
      (tsbSecurityOffersObject.twentyDollarOffEn ||
        tsbSecurityOffersObject.twentyDollarOffFr)
    ) {
      return acc;
    }
    // handling toggle of 5$ offer with 10$ bundle discount offer
    if (
      fieldValue &&
      fieldValue.includes(_tenDollarOff) &&
      value ===
      (tsbSecurityOffersObject.tenBundleDiscountEn ||
        tsbSecurityOffersObject.tenBundleDiscountFr)
    ) {
      return acc;
    }
    // handling toggle of 5$ offer with 5$ off
    if (
      fieldValue &&
      fieldValue.includes(_tenDollarOff) &&
      value ===
      (tsbSecurityOffersObject.twentyDollarOffEn ||
        tsbSecurityOffersObject.twentyDollarOffFr)
    ) {
      return acc;
    }
    // handling toggle of 10$ offer with 5$ bundle discount offer
    if (
      fieldValue &&
      fieldValue.includes(
        tsbSecurityOffersObject.tenBundleDiscountEn ||
        tsbSecurityOffersObject.tenBundleDiscountFr
      ) &&
      value === _tenDollarOff
    ) {
      return acc;
    }
    //   end logic of the offer
    if (
      ((userChannelName &&
          !secureBusinessAllowedChannelsList.includes(userChannelName)) ||
        !userChannelName) &&
      (value === tenOffMpp || value === twentyOffMpp)
    ) {
      return acc;
    }
    acc.push(item);
    return acc;
  }, []);

  if (securityPackageValue === _.startCase(packageMonitor)) {
    return optionsList.filter(
      el =>
        ![
          tsbSecurityOffersObject.twentyDollarOffEn,
          tsbSecurityOffersObject.twentyDollarOffFr
        ].includes(el.fields.value)
    );
  }
  return optionsList;
};

const getSmartCameraOffersList = (listOfAllOptions, fieldValue) => {
  const translations = useTranslationsContext();
  const {
    contentfulValues: {
      secureBusinessOffers: {
        tenOFFWireline,
        tenOFFWireless,
        installationOff,
        zeroInstallation
      }
    }
  } = translations;

  return listOfAllOptions.reduce((acc, item) => {
    const { fields } = item;
    const { value } = fields;
    if (
      (!(fieldValue && fieldValue.length) && value === zeroInstallation) ||
      (fieldValue &&
        fieldValue.includes(installationOff) &&
        value === zeroInstallation) ||
      (fieldValue &&
        (fieldValue.includes(tenOFFWireline) ||
          fieldValue.includes(tenOFFWireless) ||
          fieldValue.includes(zeroInstallation)) &&
        value === installationOff) ||
      (fieldValue &&
        fieldValue.includes(tenOFFWireless) &&
        (value === tenOFFWireline || value === installationOff)) ||
      (fieldValue &&
        fieldValue.includes(tenOFFWireline) &&
        (value === tenOFFWireless || value === installationOff)) ||
      (fieldValue &&
        fieldValue.includes(installationOff) &&
        (value === tenOFFWireline || value === tenOFFWireless))
    ) {
      return acc;
    }

    acc.push(item);
    return acc;
  }, []);
};

export {
  getSecureBusinessOffersList,
  getSmartCameraOffersList
};